// import axios from 'axios';

import axios from 'axios';
import { headers } from '../../config';
import {baseUrl} from './../../config/endpoints'

function createAxios() {
    return axios.create({
        baseURL: `${baseUrl}/purchase`,
        headers: headers()
    })
}

export default createAxios

// export default axios.create({
//     baseURL: "http://172.16.1.25:3000/",
//     headers: {
//         "Accept": "application/json",
//         "Content-Type": "application/json",
//         "X-Request-ID": Math.random(),
//         "X-User-ID": 1
//     }
// })